import { Header } from "antd/es/layout/layout";
import React, { useContext, useEffect, useState } from "react";
import { Affix, Row, Col, Button, Modal, Avatar, message } from "antd";
import wallet from "../../assets/wallet.svg";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  CloseCircleFilled,
} from "@ant-design/icons";
import "./dash-header.scss";
import walletConnectImg from "../../assets/wallet-connect.png";
import metamaskImg from "../../assets/metamask.svg";
import { getAccountDetails, getDetailsFromChainId } from "../wallet/metamask";
import { switchNetwork } from "../wallet/metamask";
import userService from "../../services/userService";
import { Web3Context } from "../wallet/walletConnect";
import { Web3Modal, useWeb3Modal } from "@web3modal/react";
import { useAccount, useDisconnect } from "wagmi";
import { useDispatch, useSelector } from "react-redux";
import { setWalletAddressValue } from "../Redux/actions";
import { ThemeContext } from "../../context/themeProvider";

const ROOT = `header_module`;

export default function DashboardHeader(props) {
  const { colorBgContainer, headerTitle, collapsed, setCollapsed } = props;
  const walletAddress = useSelector((state) => state.wallet.walletAddress);
  const dispatch = useDispatch();
  const [walletModal, setWalletModal] = useState(false);
  const _u = JSON.parse(useSelector((state) => state.user.user));
  const { ethereumClient, projectId } = useContext(Web3Context);
  const { open, close, setDefaultChain } = useWeb3Modal();
  const account = useAccount();
  const { disconnect } = useDisconnect();
  const { setLoading } = useContext(ThemeContext);

  const showConnectWalletModal = () => {
    setWalletModal(true);
  };
  const connectMetamask = async () => {
    getAccountDetails();
    setWalletModal(false);
  };
  const walletConnect = () => {
    open();
    setWalletModal(false);
  };

  const handleAccountChange = (accounts) => {
    dispatch(setWalletAddressValue(accounts[0]));
  };

  /**
   * Wallet connect address update
   */
  useEffect(() => {
    if (account?.address) {
      // setWalletModal(false)
      dispatch(setWalletAddressValue(account?.address));
    }
  }, [account]);

  /**
   * Metamask events wallet address update
   */
  useEffect(() => {
    if (walletAddress && _u) {
      getDetailsFromChainId();
    }
    try {
      window.ethereum?.on("accountsChanged", handleAccountChange);
      window.ethereum?.on("chainChanged", switchNetwork);
    } catch (error) {
      console.log(error);
      throw new Error("No ethereum Object");
    }

    return () => {
      window.ethereum?.removeListener("accountsChanged", handleAccountChange);
      window.ethereum?.removeListener("chainChanged", switchNetwork);
    };
  }, []);

  useEffect(() => {
    if (walletAddress) addWalletFunc();
    // console.log(walletAddress)
  }, [walletAddress]);

  const addWalletFunc = async () => {
    let dataToSend = {
      walletAddress: walletAddress,
    };
    try {
      setLoading(true);
      const response = await userService.addWalletApi(dataToSend);
      if (response.error) {
        message.destroy();
        message.error(
          response?.error?.message ||
            "Something went worng in adding new wallet"
        );
        disconnect(); // disconnect from wallet connect
        dispatch(setWalletAddressValue(null));
        setLoading(false);
      } else {
        setLoading(false);
        return;
      }
    } catch (error) {
      setLoading(false);
      disconnect(); // disconnect from wallet connect
      dispatch(setWalletAddressValue(null));
      return;
    }
  };
  const promotion = useSelector((state) => state.promotion.isCompleted);

  return (
    <>
      <Modal
        className={`${ROOT}__connect`}
        open={walletModal}
        title=""
        onCancel={() => setWalletModal(false)}
        closeIcon={<CloseCircleFilled />}
        centered
        footer={null}
      >
        <h5 className="text-center">
          Connect your wallet to your BAAI account to enable transactions.
        </h5>
        <div className="wrapper  mt-4">
          <Row className="text-center" align="middle">
            <Col lg={12} xs={12}>
              <div className="active">
                <Avatar
                  src={metamaskImg}
                  shape="square"
                  size={60}
                  onClick={() => connectMetamask()}
                />
                <p className="mb-0">
                  <strong>Metamask</strong>
                </p>
              </div>
            </Col>
            <Col lg={12} xs={12}>
              <div className="active">
                <Avatar
                  src={walletConnectImg}
                  shape="square"
                  size={60}
                  onClick={() => walletConnect()}
                />
                <p className="mb-0">
                  <strong>WalletConnect</strong>
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
      <Affix offsetTop={!promotion ? (window.innerWidth < 525 ? 66 : 47) : 0}>
        <Header
          style={{ padding: 0, background: colorBgContainer }}
          className={`${ROOT}__dash_header`}
        >
          <div
            style={{ position: "relative", top: "20px" }}
            className="mob_menu"
          >
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: "16px",
                width: 64,
                height: 64,
              }}
            />{" "}
          </div>
          <Row align="middle">
            <Col lg={20} xs={12} className="py-3 px-4">
              <h3 className="header_title text-truncate">{headerTitle}</h3>
            </Col>
            <Col
              lg={4}
              xs={12}
              style={{ textAlign: "right", paddingRight: "25px" }}
            >
              <Button type="light" onClick={() => showConnectWalletModal()}>
                <img src={wallet} />{" "}
                {walletAddress
                  ? walletAddress.slice(0, 5) + "..." + walletAddress.slice(-5)
                  : "Connect Wallet"}
              </Button>
            </Col>
          </Row>
        </Header>
      </Affix>
      <Web3Modal projectId={projectId} ethereumClient={ethereumClient} />
    </>
  );
}
